var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97702 7.00362H7.22188V8.82462H18.9745V7.00362H21.2413V13.5513H22.5006V5.70088H18.9745V3.88272H7.22188V5.70088H3.71771V23.3105H13.2529V22.0077H4.97702V7.00362ZM8.48119 5.18829H17.7152V7.52471H8.48119V5.18829Z",
    fill: "#606CEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8515 11.1469H18.3667V12.4496H7.8515V11.1469ZM7.8515 14.8937H14.1261V16.1964H7.8515V14.8937ZM7.8515 18.3884H12.3522V19.6911H7.8515V18.3884ZM19.3276 14.7945C16.5763 14.7945 14.3397 17.1083 14.3397 19.9545C14.3397 22.8007 16.5763 25.1145 19.3276 25.1145C22.079 25.1145 24.3156 22.8007 24.3156 19.9545C24.3156 17.1083 22.0762 14.7945 19.3276 14.7945ZM19.3276 23.8117C17.2717 23.8117 15.599 22.0814 15.599 19.9545C15.599 17.8276 17.2689 16.0973 19.3276 16.0973C21.3863 16.0973 23.0563 17.8276 23.0563 19.9545C23.0563 22.0814 21.3836 23.8117 19.3276 23.8117Z",
    fill: "#606CEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4865 17.4736H18.2272V20.8919H21.4001V19.5892H19.4865V17.4736Z",
    fill: "#606CEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingOrderIcon);
export default __webpack_public_path__ + "static/media/pendingOrderIcon.36ed6fb136aedd055f61fcc1b910e6a1.svg";
export { ForwardRef as ReactComponent };